import { Hero } from '../../components/hero/hero';
import { About } from '../../components/basic-info/basic-info';
import { Skills } from '../../components/skills/skills';
// import { Experience } from '../../components/experience/experience';
import { Websites } from '../../components/websites/websites';
import { BlogTeaser } from '../../components/blog/blog-teaser';
import { useScrollToHash } from '../../components/shared/use-scroll-to-hash';

/** The landing page: the original single-page sections, top to bottom. */
export function HomePage() {
  // Section links (`/#about`) are real router links; scroll to the target here.
  useScrollToHash();

  return (
    <main id="main">
      <Hero />
      <About />
      <Skills />
      {/* <Experience /> */}
      <Websites />
      <BlogTeaser />
    </main>
  );
}
